export enum FilterTypeEnum {
  CANDIDATE = 'candidate',
  CHECKBOX = 'checkbox',
  CURRENCY = 'currency',
  DATE = 'date',
  EXAM_TYPE = 'exam_type',
  LOCAL_EXAME = 'local_exame',
  NUMBER = 'number',
  RADIOBOX = 'radiobox',
  SELECT = 'select',
  TEXT = 'text',
  AUTOCOMPLETE = 'autocomplete',
  CFCS = 'cfcs',
  BOOLEAN = 'boolean',
  PERSON = 'person'
}

export enum OperacaoMatriculaEnum {
  CADASTRO = 'cadastro',
  EDICAO = 'edicao',
  EXCLUSAO = 'exclusao',
}
